// Libraries
import React from 'react';
import ReactDOM from 'react-dom/client';

// Main app component
import App from './App';

// Setting up React
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);